export default (state = {}, action) => {
    switch (action.type) {
        case 'SET_IMOVEIS':
            return action.imoveis;
        case 'CRIAR_IMOVEIS':
            return [...state, action.imoveis];
        case 'EDITAR_IMOVEIS':
            return state.map((imoveis) => (
                (imoveis.id === action.imoveis.id) ? (
                    action.imoveis
                ) : (
                    imoveis
                    )
            ));
        case 'ELIMINAR_IMOVEIS':
            return state.filter((imoveis) => (
                imoveis.id !== action.imoveisId
            ));
        default:
            return state;
    }
};
